import UpgradeBadge from '../../../session/components/Badge/Upgrade/UpgradeBadge';
import Avatar, { AvatarProps } from './Avatar';

export type SubscriptionAvatarProps = AvatarProps & {
  premium?: boolean;
};
const SubscriptionAvatar = ({ premium, ...rest }: SubscriptionAvatarProps) => (
  <Avatar {...rest}>{premium && <UpgradeBadge title="Premium" overlay />}</Avatar>
);

export default SubscriptionAvatar;
